import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import VariablePicker from '../VariablePicker/VariablePicker';
import { TextInput } from '../TextInput/NewTextInput';

const useStyles = makeStyles((theme) => ({
  root: { '&>*': { marginTop: 10 } },
  input: { width: '45%' },
  rowRange: {
    display: 'inline-block',
    width: '45%',
    '&:first-child': { paddingRight: 5 },
    '&:last-child': { paddingLeft: 5 }
  }
}));

export function Loop({ action, inputName, variables, setOpenVariable, variableRender, }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const label = 'CONTENT.CONFIGURATION-FORM.REPEATABLE.REPEAT.';
  const [iterator, setIterator] = useState('');
  const [loopThrough, setLoopThrough] = useState('ALL_ROWS');
  const [fromRow, setFromRow] = useState(0);
  const [toRow, setToRow] = useState(0);
  const [times, setTimes] = useState(0);

  useEffect(() => {
    if (!action.fields.repeatSource) { action.fields.repeatSource = { value: '', isRequired: true }; }
    else { setIterator(action.fields.repeatSource.value); }
    if (!action.fields.repeatType) { action.fields.repeatType = { value: 'ALL_ROWS', isRequired: false }; }
    else { setLoopThrough(action.fields.repeatType.value ? action.fields.repeatType.value : 'ALL_ROWS'); }
    if (!action.fields.fromRow) { action.fields.fromRow = { value: 0, isRequired: false }; }
    else { setFromRow(action.fields.fromRow.value); }
    if (!action.fields.toRow) { action.fields.toRow = { value: 0, isRequired: false }; }
    else { setToRow(action.fields.toRow.value); }
    if (!action.fields.times) { action.fields.times = { value: 0, isRequired: false }; }
    else { setTimes(action.fields.times.value); }
  }, [action, variables]);

  const handleIteratorChange = (event) => {
    setIterator(event.target.value);
    setLoopThrough('ALL_ROWS');
    action.fields.repeatSource.value = event.target.value;
  };

  const handleLoopThroughChange = (event) => {
    setLoopThrough(event.target.value);
    action.fields.repeatType.value = event.target.value;
  };
  const handleTimesChange = (event) => {
    if (event.target.value >= 0) {
      setTimes(event.target.value);
      action.fields.times.value = event.target.value;
    }
  };

  const handleFromRowChange = (event) => {
    if (event.target.value >= 0) {
      setFromRow(event.target.value);
      action.fields.fromRow.value = event.target.value;
    }
  };

  const handleToRowChange = (event) => {
    if (event.target.value >= 0) {
      setToRow(event.target.value);
      action.fields.toRow.value = event.target.value;
    }
  };

  return (
    <div className={classes.root}>
      <div className="form-element">
        <div>{t(label + 'REPEAT_SOURCE')}</div>
        <FormControl fullWidth style={{ width: '90%' }}>
          <Select variant='outlined' defaultValue='' value={iterator} onChange={handleIteratorChange}>
            <MenuItem value=''>
              <em>{t(label + 'CHOOSE_AN_ITERATOR')}</em>
            </MenuItem>
            <ListSubheader value=''>Excel</ListSubheader>
            <MenuItem className={classes.formControl} value={'EXCEL_EACH_ROW'}>
              {t(label + 'EXCEL-EACH-ROW')}
            </MenuItem>
            <ListSubheader value=''>{t(label + 'VARIABLE')}</ListSubheader>
            <MenuItem className={classes.formControl} value={'VARIABLE_EACH_DATA'}>
              {t(label + 'VARIABLE_EACH_DATA')}
            </MenuItem>
            <ListSubheader value=''>{t(label + 'MAIL')}</ListSubheader>
            <MenuItem className={classes.formControl} value={'MAIL_EACH_VARIABLE'}>
              {t(label + 'MAIL_EACH_VARIABLE')}
            </MenuItem>
            {/* <ListSubheader value=''>{t(label + 'REPEAT')}</ListSubheader><MenuItem className={classes.formControl} value={'LOOP'}>{t(label + 'FOR_N_TIMES')}</MenuItem> */}
          </Select>
        </FormControl>
      </div>
      {iterator === 'EXCEL_EACH_ROW' && (
        <div className={classes.formControl}>
          <div className="form-element">
            {t('CONTENT.CONFIGURATION-FORM.EXCEL.COPY.EXCEL-SOURCE')}
            <VariablePicker action={action} inputName="excelSource" variables={variables}
              setOpenVariable={setOpenVariable} filter="data table" isRequired />
            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
          </div>
          <div className="form-element">
            <div>{t(label + 'LOOP_THROUGH')}</div>
            <FormControl variant='outlined' fullWidth style={{ width: '90%' }}>
              <Select value={loopThrough} onChange={handleLoopThroughChange}>
                <MenuItem value=''>
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'ALL_ROWS'}>{t(label + 'ALL-ROWS')}</MenuItem>
                <MenuItem value={'SPECIFIC_ROWS'}>
                  {t(label + 'SPECIFIC_ROWS')}
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          {loopThrough === 'SPECIFIC_ROWS' && (
            <div className="form-element">
              <div className={classes.rowRange}>
                <div>{t(label + 'FROM-ROW')}</div>
                <TextField variant='outlined' type='number' onChange={handleFromRowChange} value={fromRow} fullWidth
                />
              </div>
              <div className={classes.rowRange}>
                <div>{t(label + 'TO-ROW')}</div>
                <TextField variant='outlined' type='number' onChange={handleToRowChange} value={toRow} fullWidth
                />
              </div>
            </div>
          )}
          <div className="form-element">
            {t(label + 'ASSIGN_TO_VARIABLE')}
            <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} filter='array' isRequired variableRender={variableRender} />
            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
          </div>
          <div className="form-element">
            {t(label + 'ASSIGN-INDEX')}
            <VariablePicker action={action} inputName="setIndex" variables={variables} setOpenVariable={setOpenVariable} filter="number" />
            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'number' })}</em></small>
          </div>
        </div>
      )}
      {iterator === 'LOOP' && (
        <div className={classes.formControl}>
          <div>{t(label + 'TIMES')}</div>
          <TextField variant='outlined' type='number' onChange={handleTimesChange} value={times} fullWidth />
        </div>
      )}
      {iterator && iterator !== '' && iterator === 'VARIABLE_EACH_DATA' && (
        <>
          <div className="form-element">
            <div className="form-element">
              {t(label + 'DATA-OF-THE-LIST')}
              <TextInput action={action} inputName="listData" variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} />
            </div>
            <div className="form-element">
              {t(label + 'CHOOSE-VARIABLE')}
              <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} />
              <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'any' })}</em></small>
            </div>
            <div className={classes.formControl}>
              {t(label + 'ASSIGN-INDEX')}
              <VariablePicker action={action} inputName="setIndex" variables={variables} setOpenVariable={setOpenVariable} filter="number" />
              <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'number' })}</em></small>
            </div>
          </div>
        </>
      )}
      {iterator === 'MAIL_EACH_VARIABLE' ? (
        <>
          <div className="form-element">
            <div className="form-element">
              {t(label + 'DATA-OF-THE-LIST')}
              <VariablePicker action={action} inputName="listData" variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} filter="array" />
              <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
            <div className="form-element">
              {t(label + 'CHOOSE-VARIABLE')}
              <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} filter="object" />
              <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'object' })}</em></small>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}